/* serve 服务商 */

import MyCard from "../pages/serve/pages/vip/myCard"; //新建会员卡
import Vip from "../pages/serve/pages/vip/vip"; //修改会员卡内容
import CardCantent from "../pages/serve/pages/vip/cardCantent"; //一键开卡 字段设置
import GetCode from "../pages/serve/pages/vip/getCode"; //领卡二维码
import Feed from "../pages/serve/pages/basic/feed"; //商户进件
import MchApplyHistery from "../pages/serve/pages/basic/mchApplyHistery"; //商户进件
import Log from "../pages/serve/pages/basic/log"; //日志页面
import CreateMerchant from "../pages/serve/pages/basic/createMerchant"; //创建店铺
// import Shome from "../pages/serve/pages/shome";//
import Sinformation from "../pages/serve/pages/basic/sinformation"; //服务商信息
import Advertised from "../pages/serve/pages/basic/advertised"; //
import ChangeBank from "../pages/serve/pages/basic/changeBank"; //绑定银行修改
import UserGroup from "../pages/serve/pages/people/userGroup"; //用户组
import Permission from "../pages/serve/pages/people/permission"; //所有权限
import MchPermission from "../pages/serve/pages/people/mchPermission"; //所有权限

import SonService from "../pages/serve/pages/basic/sonService"; //子服务商
import Goodsinfo from "../pages/serve/pages/basicgoodsinfo/goodsInfo"; //商品基本库
import AuditGoods from "../pages/serve/pages/basicgoodsinfo/auditGoods"; //商品基本库
import MchSalesList from "../pages/serve/pages/basicgoodsinfo/mchSalesList.vue"; //商品基本库
import OnlineBaseClassInfo from "../pages/serve/pages/basicgoodsinfo/onlinebaseclassinfo.vue"; //
import ShopManage from "../pages/serve/pages/shop/shopmanage"; //查询店铺 （老）
import UnderInfo from "../pages/serve/pages/shop/underinfo"; //所有门店 版本和ip信息
import ServiceSwift from "../pages/serve/pages/paySet/serviceSwift"; //服务商配置swift //
import SwiftConfigure from "../pages/serve/pages/paySet/swiftConfigure"; //配置店铺威富通信息

export default [
  { path: "/underinfo", name: "underinfo", component: UnderInfo },
  { path: "/userGroup", name: "userGroup", component: UserGroup },
  { path: "/permission", name: "permission", component: Permission },
  { path: "/mchPermission", name: "mchPermission", component: MchPermission },
  { path: "/feed", name: "feed", component: Feed },
  { path: "/mchApplyHistery", name: "mchApplyHistery", component: MchApplyHistery },

  { path: "/log", name: "log", component: Log },
  {
    path: "/swiftConfigure",
    name: "swiftConfigure",
    component: SwiftConfigure
  },
  {
    path: "/createMerchant",
    name: "createMerchant",
    component: CreateMerchant
  },
  {
    path: "/serviceSwift",
    name: "serviceSwift",
    component: ServiceSwift
  },

  { path: "/sonService", name: "sonService", component: SonService },

  {
    path: "/onlinebaseclassinfo",
    name: "onlinebaseclassinfo",
    component: OnlineBaseClassInfo
  },

  { path: "/shopmanage", name: "shopmanage", component: ShopManage },
  { path: "/sinformation", name: "sinfomation", component: Sinformation },
  { path: "/advertised", name: "advertised", component: Advertised },
  { path: "/vip", name: "vip", component: Vip },

  { path: "/getCode", name: "getCode", component: GetCode },
  { path: "/cardCantent", name: "cardCantent", component: CardCantent },

  { path: "/changeBank", name: "changeBank", component: ChangeBank },
  { path: "/MyCard", name: "MyCard", component: MyCard },

  { path: "/goodsInfo", name: "goodsInfo", component: Goodsinfo },
  { path: "/auditGoods", name: "auditGoods", component: AuditGoods },

  { path: "/mchSalesList", name: "mchSalesList", component: MchSalesList }
]
